"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCollectionWrapper = exports.StyledSearchBoxWrapper = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
`;
exports.StyledSearchBoxWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledCollectionWrapper = styled_components_1.default.div `
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};

  img {
    background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  }
`;
//# sourceMappingURL=CollectionOverView.style.js.map